import { D28 } from "./ShareByCustomerGroupSales/D28"
import { D28_04 } from "./PesoSalesAndNumberOfCustomers/D28_04"

export const DistrictCustomerSales = {
  "sections": [
    D28_04,
    D28
  ]
}
